import EmptyState from '@components/v2/ui/EmptyState/EmptyState';
import { Stack } from '@mui/material';
import LangEnum from '../../../../../lang/LangEnum';
import { CatalogProductsTestIds } from '../../../../../utils/testIds/CatalogProducts.testIds';

interface CatalogListErrorProps {
  onRetry: () => void;
}

const CatalogListError = ({ onRetry }: CatalogListErrorProps) => (
  <Stack sx={{ flex: '1 0 auto', alignItems: 'center', justifyContent: 'center', p: 3 }}>
    <EmptyState
      testId={CatalogProductsTestIds.LIST_ERROR}
      title={{ text: LangEnum.CATALOG_PRODUCTS_V2_LIST_ERROR }}
      action={{ primary: { label: LangEnum.GLOBAL_TRY_AGAIN, onClick: onRetry } }}
    />
  </Stack>
);

export default CatalogListError;
